export const getters = {
  getOverrides($state) {
    return $state.overrides;
  },
  getSource($state) {
    return $state.source;
  },
  getUserConversationMenu($state) {
    return $state.userConversationMenu;
  },
};
